module.exports = __webpack_public_path__ + "static/media/APP_TimeMagician_152x174_1.5fa5ee64.png";